query getEmployeeSurvey($surveyCode: String, $previewEmployeeId: Int) {
  employeeSurvey(hashCode: $surveyCode, previewEmployeeId: $previewEmployeeId) {
    id
    name
    companyId
    status {
      name
    }
    isPreview
    showResults
    anonymousConversation
    submitted
    expired
    employeePreferredLanguageId
    questions {
      id
      orderIndex
      showSkipButton
      type {
        name
      }
      question {
        ... on SurveyElementMessage {
          messagesPerLanguage {
            message
            description
            language {
              langISOCode
            }
          }
        }
        ... on SurveyElementQuestionScale {
          ratingOptionLowest
          ratingOptionHighest
          required
          showTextComment
          showLabels
          showDescription
          icon {
            name
          }
          messagesPerLanguage {
            message
            description
            labelBefore
            labelAfter
            language {
              langISOCode
            }
          }
        }
        ... on SurveyElementQuestionText {
          required
          showDescription
          messagesPerLanguage {
            message
            description
            language {
              langISOCode
            }
          }
        }
        ... on SurveyElementQuestionOptions {
          required
          showDescription
          showTextComment
          minSelectedOption
          maxSelectedOption
          messagesPerLanguage {
            message
            description
            description
            language {
              langISOCode
            }
          }
          choices {
            id
            orderIndex
            messagesPerLanguage {
              message
              language {
                langISOCode
              }
            }
          }
        }
      }
    }
    answers {
      questionId
      comment
      rating
      skippedQuestion
      answerText
      selectedOptions
    }
    languages {
      id
      langISOCode
    }
    questionLogics {
      id
      surveyId
      mainSurveyElementId
      affectedSurveyElementId
      rating
      surveyElementQuestionOptionsChoiceId
      isEqualsTo
    }
    anonymityThreshold
  }
}
